import { AbstractControl, ValidationErrors } from '@angular/forms';

export function zeroNotAllowedValidator(control: AbstractControl): ValidationErrors | null {
    return control.value === 0 ? { zeroNotAllowed: true } : null;
}

export function urlValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
        return null;
    }

    const urlPattern = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;

    const isValid = urlPattern.test(control.value);

    return isValid ? null : { invalidUrl: true };
}

export function decimalNumberValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value?.toString().trim();

  if (!value) {
    return null;
  }

  const pattern = /^(?:\$\d+(\.\d+)?|\d+(\.\d+)?%)$/;

  if (!pattern.test(value)) {
    return { invalidFormat: true };
  }

  const numericValue = parseFloat(value.replace(/[$%]/g, ''));

  if (isNaN(numericValue)) {
    return { invalidNumber: true };
  }

  if (numericValue < 0) {
    return { negativeNotAllowed: true };
  }

  // if (numericValue > 100) {
  //   return { maxValueExceeded: true };
  // }

    return null;
}

export function positiveNumberValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
        return null; // Field is optional, so empty is valid
    }

    const value = control.value.toString().trim();
    // Allow only positive decimal and integer numbers
    // Pattern allows: integers (123), decimals (123.45), but not negative numbers
    const decimalPattern = /^\d+(\.\d+)?$/;
    const isValidFormat = decimalPattern.test(value);

    if (!isValidFormat) {
        return { invalidDecimal: true };
    }
    return null;
}
